import React from 'react';
import BaseComponent from './BaseComponent';
import Event from './Event';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import classNames from 'classnames';
import {List, ListItem, ListBody, ListTitle} from './UIList';

class BandItem extends BaseComponent {
    render() {
        const {active, to, band} = this.props;

        return <ListItem active={active} to={to}>
            <ListBody><ListTitle>{band}</ListTitle></ListBody>
        </ListItem>;
    }
}

export class PureBandList extends BaseComponent {
    render() {
        const {entries, selectedBand} = this.props;
        const bands = entries.map(e => e.band).toSet().sort();

        return <div className="band-list">
            <List>
                {bands.map(band => {
                    const path = `/band/${band}`;
                    const active = selectedBand === band;
                    return <BandItem active={active} key={band} to={path} band={band} />;
                    return <ListItem active={active} key={band} to={path}>
                        <ListBody><ListTitle>{band}</ListTitle></ListBody>
                    </ListItem>;
                })}
            </List>
        </div>;
    }
}

function mapStateToProps({app}) {
    return {entries: app.get('entries')};
}

export default connect(mapStateToProps)(PureBandList);



/** WEBPACK FOOTER **
 ** ./src/components/BandList.jsx
 **/